module.exports = __webpack_public_path__ + "media/images/athletes/1564-78a85558421ea216597ec3981a1efe6a.png";